import { defineStore } from 'pinia';
import apiFetch from '@wordpress/api-fetch';

export const useSectorsStore = defineStore('sectors', {
  state: () => ({
    sectors: [],
    activeSectors: [],
  }),

  actions: {
    loadSectors(params = {}) {
      this.sectors = [];

      try {
        const context = this;
        const query = new URLSearchParams();

        if (params.lang) {
          query.append('lang', params.lang);
        }

        apiFetch({
          path: `/wp-json/ebus/sectors?${query.toString()}`,
        }).then((sectorsData) => {
          context.sectors = sectorsData;
        });
      } catch (error) {
        console.log('Error: ', error);
      }
    },

    toggleSector(sector) {
      const index = this.activeSectors.indexOf(sector);

      if (index === -1) {
        this.activeSectors.push(sector);
      } else {
        this.activeSectors.splice(index, 1);
      }
    },

    resetActiveSectors() {
      this.activeSectors = [];
    },
  },
})
